<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6">
    </div>
    <div class="col-12 md:col-6 lg:col-6">
      <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
             (input)="banco.filterGlobal($event.target.value, 'contains')"
             name="banco">
    </div>
  </div>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" #banco
               [value]="lisBancoPregunta" dataKey="idPregunta" [(selection)]="preSeleccionadas"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th style="width: 3em">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-index="rowIndex">
          <tr [pSelectableRow]="row">
            <td>
              <p-tableCheckbox [value]="row"></p-tableCheckbox>
            </td>
            <td>{{row.codigo}}</td>
            <td>{{row.nombre}}</td>
            <td>{{row.tipoPregunta}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="grid form-group" *ngIf="submitted && preSeleccionadas.length===0">
    <div class="col-12 md:col-12 lg:col-12">
      <div class="div-form">
        <div class="p-message p-messages-error p-corner-all">
          {{ 'CUESTIONARIOPREGUNTA.MSG_SELECCIONEUNREGISTRO' | translate}}
        </div>
      </div>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <div *ngIf="!guardando">
        <a (click)="regresar(preSeleccionadas.length >0 ? true : false)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
        <button icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}"
                type="button"
                (click)="guardar()"
                pButton></button>
      </div>
      <div *ngIf="guardando">
        <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
        <span>{{'LBL_GUARDANDO' | translate }}</span>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog #cd key="pregunta-banco">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
